import React, { Component } from 'react';
import rulingMachine from '../videos/ruling-machine.mp4';
import CloseButton from '../components/closeButton';
import PlayButton from '../components/playButton';
import printText from '../images/printText.png';
import shawPen from '../images/ShawPen.png';
import Loader from 'react-loader-spinner'
import Subtitles from './subtitles';

class Video extends Component {
  constructor(props) {
    super(props);
    let video = null;
    this.state = {
      shouldPlay: false,
      paused: false
    };
  }

  closeVideo() {
    this.setState({
      shouldPlay: false,
    });

    this.props.onClose();
  }

  componentWillMount(){
    this.setState({
      shouldPlay: true
    })
  }

  componentWillReceiveProps(newProps)
  {
    if(newProps.videoUrl !== this.props.videoUrl) {
      this.setState({
        shouldPlay: true
      })
    }
  }

  playVideo() {
    this.setState({ shouldPlay: true });
  }

  playNext(){
   this.props.playNext()
   this.setState({shouldPlay: false})
  }

  onNext(){
    this.setState({ shouldPlay: false });
   this.props.onNext()
  }

  onPrev(){
    this.setState({ shouldPlay: false });
    this.props.onPrev()
  }

  render() {
    console.log(imageUrl)
    const { prevText, nextText, imageUrl, noLast, noFirst, videoUrl, subtitles, subtitlesIrish } = this.props;
    const image = require(`../images/${imageUrl}`);
    let vid = `https://zoner.b-cdn.net/printmuseum/${videoUrl}.mp4`;

    if (this.state.shouldPlay) {
      //this.video.play()
    }
    return (
      <div
        style={{
          background: 'black',
          flex: 1,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundImage:
            'linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(' +
            image +
            ')',
        }}
        className="video-wrapper"
      >
        <CloseButton onClose={() => this.closeVideo()} />
    
        {this.state.shouldPlay ? (
        
          <video
            style={{ objectFit: 'cover',    width: '100%',
            height: '100%'}}
            onPause={() => this.setState({paused: true})}
            onPlay={() => this.setState({paused: false})}
            controls  
            ref={element => (this.video = element)}
            key={vid} 
            
            autoPlay={true}
            onEnded={() => this.playNext()}
            id="background-video"
            autoPlay
          >
            
            { subtitles && <Subtitles subtitles={subtitles} default={true} label={"English"} /> }
            {/*Irish*/}
            { subtitles && <Subtitles subtitles={subtitlesIrish} srcLang={'ga'} label={"Irish"} /> }
            <source src={vid} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
       
        ) : null}

        <div style={noFirst ? {zIndex: -5} : {}} onClick={() => this.onPrev()} className="navigation left-side">
        <div  className="left arrow"> </div>
        <div className="text-wrap"> <p>{prevText && this.state.paused ? 'previous' : ''} <span>{prevText && this.state.paused ? 'printer' : ''} </span> </p> </div>
        </div>
        
        <PlayButton onPlay={() => this.playVideo()} />

        <div style={noLast ? {zIndex: -5} : {}} className="navigation right-side" onClick={() => this.onNext()}>
           <div className="text-wrap"><p>{nextText && this.state.paused ? 'next' : ''} <span>{nextText && this.state.paused ? 'printer' : ''} </span> </p></div>
          <div  className="right arrow" />
        </div>
        <div className="previous" />
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/video.js